import { each, pipe } from '@fxts/core';

export const deleteKeys = <T extends object = object>(object: T, ...keys: (keyof T)[]) => {
  pipe(
    keys,
    each((key) => key in object && delete object[key]),
  );
};

export const assignKeys = <T extends object>(object: T, value: unknown, ...keys: string[]) => {
  pipe(
    keys,
    each((key) => {
      (object as Record<string, unknown>)[key] = value;
    }),
  );
};
